<template>
  <div class="call" v-if="chatId">
    <div v-show="!minimized" class="video" ref="visio"></div>
    <div class="minimize pointer" :class="{compact: minimized}" @click.prevent="minimize">
      <angle-icon></angle-icon>
    </div>
  </div>
</template>
<script>
import JitsiMeetExternalAPI from 'lib-jitsi-meet-dist/dist/external_api.min.js'
import { mapGetters, mapMutations } from 'vuex'
import AngleIcon from '@/components/Icons/Angle'
export default {
  components: {
    AngleIcon
  },
  data () {
    return {
      loading: false,
      jitsi: null,
      minimized: false,
      headerHeight: 0
    }
  },
  computed: {
    ...mapGetters({
      authType: 'auth/type',
      authName: 'auth/name',
      authToken: 'auth/token',
      authAvatar: 'auth/avatar',
      staticUrl: 'app/staticUrl',
      callStatus: 'call/status',
      callerId: 'call/callerId',
      isMuted: 'call/muted',
      chatId: 'call/chatId',
      chat: 'call/chat',
      user: 'call/user',
      videoInited: 'call/videoInited',
      isCompact: 'call/compact'
    })
  },
  watch: {
    callStatus (val) {
      switch (val) {
        case 'pending': // (ზარი წამოწყებულია)
          this.loading = true
          break
        case 'pending_busy': // (დაკავებაა)
          this.busy()
          break
        case 'ringing_declined': // (მომხმარებელმა უარი თქვა ზარზე)
          this.declined()
          break
        case 'pending_unreachable': // (გასულია მომსახურების ზონიდან)
        case 'pending_finished': // ზარი დაასრულა მომხმარებელმა
        case 'pending_disconnected':
        case 'pending_failed':
        case 'ringing_missed': // (ზარის რეკვას გაუვიდა დრო)
        case 'ringing_finished':
        case 'ringing_disconnected':
        case 'ringing_failed':
        case 'ongoing_finished': // (ზარი დაასრულა მომხმარებელმა)
        case 'ongoing_disconnected': // (სოკეტ კონექშენი გაწყდა)
        case 'ongoing_failed': // (ტექნიკური პრობლემის გამო ერთერთი მომხმარებლის მხარეს გაწყდა ზარი)
          this.finish()
          break
        case 'ringing': // (ზარი რეკავს)
          this.ringing()
          break
        case 'ongoing': // (ზარი მიმდიანრეობს)
          this.answered()
          break
      }
    }
  },
  methods: {
    ...mapMutations({
      call: 'call/call',
      callFinish: 'call/finish',
      reset: 'call/reset',
      answer: 'call/answer',
      videoTagInit: 'call/initVideo',
      setHeadHeight: 'head/setHeight'
    }),
    minimize () {
      this.minimized = !this.minimized
      if (this.minimized) {
        this.setHeadHeight(82)
      } else {
        this.setHeadHeight(this.headerHeight)
      }
    },
    ringing () {
      console.log('ringing')
      if (!this.callerId) {
        this.initVisio()
        // this.initVideo(1)
      }
      this.loading = false
    },
    answered () {
      console.log('answered')
      this.initVisio()
      // this.initVideo(2)
      this.loading = false
    },
    initVisio () {
      this.minimized = false
      const domain = 'visio.ge'
      const winWidth = window.innerWidth
      const winHeight = window.innerHeight - 65
      let width = winWidth; let height = winHeight
      if (window.innerWidth / window.innerHeight < 0.7) {
        // height = winHeight
        // width =
      } else {
        if (winWidth * 0.5625 > winHeight) {
          height = winHeight
          width = parseInt(winHeight * 1.7777)
        } else {
          width = winWidth
          height = winWidth * 0.5625
        }
        if (width > 768) {
          width = 768
          height = width * 0.5625
        }
      }
      this.headerHeight = height + 82
      this.setHeadHeight(this.headerHeight)

      const options = {
        roomName: this.chatId,
        width: width,
        height: height,
        parentNode: this.$refs.visio,
        interfaceConfigOverwrite: {
          // filmStripOnly: true,
          DEFAULT_BACKGROUND: '#3e81ca',
          SHOW_JITSI_WATERMARK: false,
          SHOW_WATERMARK_FOR_GUESTS: false,
          AUTHENTICATION_ENABLE: false,
          p2p: {
            enabled: false
          },
          TOOLBAR_BUTTONS: [
            'microphone', 'camera', 'closedcaptions', 'fullscreen',
            'fodeviceselection', 'hangup', 'recording', 'settings',
            'videoquality', 'filmstrip', 'shortcuts', 'tileview',
            'videobackgroundblur', 'download'
          ]
        }
      }
      if (!this.jitsi) {
        this.jitsi = new JitsiMeetExternalAPI(domain, options)
      }
      this.jitsi.executeCommand('displayName', this.authName)
      this.jitsi.executeCommand('avatarUrl', `${this.staticUrl}${this.authAvatar}`)
      this.jitsi.executeCommand('subject', 'კონსულტაცია')
      this.jitsi.addEventListener('videoConferenceLeft', this.callFinish)
      this.videoTagInit()
    },
    declined () {
      console.log('declined')
      this.finish()
    },
    busy () {
      console.log('busy')
      this.finish()
    },
    finish () {
      this.minimized = false
      this.setHeadHeight(60)
      // this.$refs.webrtc.leave()
      if (this.jitsi) {
        this.jitsi.executeCommand('hangup')
      }
      this.jitsi = null
      this.reset()
      console.log('finish')
      this.loading = false
      // this.$router.push({ path: `/chats/${this.chatId}` })
    },
    startCall () {
      // this.initVideo(1)
      this.initVisio()
      this.call(this.chatId)
    },
    onLeave () {
      this.callFinish()
      console.log('left')
    }
  }
}
</script>
<style lang="scss">
.call {
  position: absolute;
  z-index: 100;
  margin: auto;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  top: 58px;
  background-color: #555;
  .video {
    text-align: center;
  }
  .minimize {
    width: 100%;
    text-align: center;
    background: #555;
    margin-top: -7px;
    &.compact {
      margin-top: 0px;
      svg {
        transform: rotate(0deg)
      }
    }
    svg {
      transition: all 0.2s;
      width: 24px;
      height: 24px;
      color: #fff;
      transform: rotate(180deg)
    }
  }
}
</style>
